<template>
    <div class="field-group inline">
        <label v-for="item in list">
            <input type="checkbox" name="types" :value="item.value" v-model="selected">
            <span>{{item.title}}</span>
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: []
            },
            min: {
                type: Number,
                default: 0
            },
            max: {
                type: Number,
                default: 4
            }
        },
        data() {
            return {
                list: [],
                selected: this.value
            }
        },
        created() {
            let range = [];
            let i = 0;

            if (this.min == 0) {
                range.push({
                    title: "Студия",
                    value: {minimum: 0, maximum: 0}
                });
                i++
            }
            
            for ( /* look up! */ ; i < this.max; i++) {
                range.push({
                    title: i,
                    value: {
                        minimum: i,
                        maximum: i
                    }
                });
            }

            if (this.min < this.max) {
                range.push({
                    title: `${this.max}+`,
                    value: {
                        minimum: this.max,
                        maximum: 999 // hack!
                    }
                });
            }
            
            this.list = range;
        },
        watch: {
            selected() {
                this.$emit("input", this.selected);
            }
        }
    }
</script>